module.exports = __webpack_public_path__ + "static/media/AR-screens_01.e03d80cb.png";